<div class="flex align-items-center justify-content-center min-h-screen">
  <div class="col-11 sm:col-8 md:col-6 lg:col-5 xl:col-4">
      <p-card styleClass="shadow-2">
          <ng-template pTemplate="header">
              <h2 class="text-center m-0 py-3 text-xl font-semibold text-700">
                  {{ "i18n.base.forgot-password.header" | translate }}
              </h2>
          </ng-template>
          
          <form [formGroup]="forgotPasswordForm" *ngIf="!forgotPasswordSuccess" class="p-fluid">
              <p class="text-600 mb-4 text-sm">
                  {{ "i18n.base.forgot-password.info" | translate }}
              </p>
              
              <div class="field">
                  <label for="userName" class="text-600 mb-2 block">
                      {{ "i18n.base.forgot-password.userName" | translate }}
                  </label>
                  <input 
                      pInputText 
                      id="userName" 
                      formControlName="userName" 
                      class="w-full p-2"
                      [required]="true">
                  <app-error-messages [control]="formFields.userName"></app-error-messages>
              </div>

              <div class="flex gap-2 mt-4">
                  <p-button 
                      (onClick)="formSubmit()"
                      [disabled]="!forgotPasswordForm.valid"
                      styleClass="flex-1 p-button-raised"
                      [label]="'i18n.base.forgot-password.submit-button' | translate">
                  </p-button>
                  
                  <p-button 
                      [routerLink]="loginRoute"
                      styleClass="flex-1 p-button-outlined"
                      [label]="'i18n.base.forgot-password.back-button' | translate">
                  </p-button>
              </div>
          </form>

          <div *ngIf="forgotPasswordSuccess" class="text-center">
              <i class="pi pi-check-circle text-3xl text-green-500 mb-3"></i>
              <p class="text-600">
                  {{ "i18n.base.forgot-password.success-info" | translate }}
              </p>
          </div>
      </p-card>
  </div>
</div>
